import { handleActions } from "redux-actions";
import {
  ABOUT_TOGGLE,
  LANGUAGES_TOGGLE,
  LEVELS_TOGGLE,
  LOGIN_TOGGLE,
  PAYWALL_TOGGLE,
  PLAYERS_TOGGLE,
  PRIZES_TOGGLE,
  SECRET_TOGGLE,
  SETTINGS_TOGGLE,
  SOLVED_TOGGLE
} from "./actions";
import { SET_SOLVED } from "../crossword/actions";

const initialState = {
  showSettings: false,
  showLevels: false,
  showLogin: false,
  showPaywall: false,
  showSecret: false,
  showSolved: false,
  showLanguages: false,
  showPlayers: false,
  showPrizes: false,
  showAbout: false
};

// Sets the value or negates/toggles the current value
const toggleOrSet = (value, current) =>
  Boolean(value !== undefined ? value : !current);

export default handleActions(
  {
    [SETTINGS_TOGGLE]: (state, { payload }) => ({
      ...state,
      showSettings: toggleOrSet(payload, state.showSettings),
      showLevels: false
    }),
    [LEVELS_TOGGLE]: (state, { payload }) => ({
      ...state,
      showLevels: toggleOrSet(payload, state.showLevels),
      showSettings: false
    }),
    [LOGIN_TOGGLE]: (state, { payload }) => ({
      ...state,
      showLogin: toggleOrSet(payload, state.showLogin)
    }),
    [PAYWALL_TOGGLE]: (state, { payload }) => ({
      ...state,
      showPaywall: toggleOrSet(payload, state.showPaywall)
    }),
    [SECRET_TOGGLE]: (state, { payload }) => ({
      ...state,
      showSecret: toggleOrSet(payload, state.showSecret)
    }),
    [SOLVED_TOGGLE]: (state, { payload }) => ({
      ...state,
      showSolved: toggleOrSet(payload, state.showSolved)
    }),
    [SET_SOLVED]: (state, { payload }) => ({
      ...state,
      showSolved: toggleOrSet(payload, state.showSolved)
    }),
    [LANGUAGES_TOGGLE]: (state, { payload }) => ({
      ...state,
      showLanguages: toggleOrSet(payload, state.showLanguages)
    }),
    [PLAYERS_TOGGLE]: (state, { payload }) => ({
      ...state,
      showPlayers: toggleOrSet(payload, state.showPlayers)
    }),
    [PRIZES_TOGGLE]: (state, { payload }) => ({
      ...state,
      showPrizes: toggleOrSet(payload, state.showPrizes)
    }),
    [ABOUT_TOGGLE]: (state, { payload }) => ({
      ...state,
      showAbout: toggleOrSet(payload, state.showAbout)
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/ui/reducer.js